import { render, staticRenderFns } from "./LoginAs.vue?vue&type=template&id=0bee1ea6"
import script from "./LoginAs.vue?vue&type=script&lang=js"
export * from "./LoginAs.vue?vue&type=script&lang=js"
import style0 from "./LoginAs.vue?vue&type=style&index=0&id=0bee1ea6&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports